import { render, staticRenderFns } from "./ShipsTable.vue?vue&type=template&id=6ce4e62b&scoped=true&"
import script from "./ShipsTable.vue?vue&type=script&lang=js&"
export * from "./ShipsTable.vue?vue&type=script&lang=js&"
import style0 from "./ShipsTable.vue?vue&type=style&index=0&id=6ce4e62b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce4e62b",
  null
  
)

export default component.exports